import { useT } from "@/i18n";
import { cn } from "@/lib/cn";

export default function Logo({ compact, className }: { compact?: boolean; className?: string }) {
  const { t } = useT();
  return (
    <span className={cn("inline-flex items-center gap-2", className)} aria-label={t("nav.portal")}>
      <svg className="h-7 w-7" viewBox="0 0 32 32" aria-hidden="true">
        <defs>
          <linearGradient id="applogo-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2563eb" />
            <stop offset="100%" stopColor="#1d4ed8" />
          </linearGradient>
        </defs>
        <path
          d="M16 2 L28 6 V16 C28 23 22 28 16 30 C10 28 4 23 4 16 V6 Z"
          fill="url(#applogo-g)"
        />
        <path
          d="M10 16 l4 4 l8 -9"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      <span className={cn("font-semibold tracking-tight text-[17px] text-slate-900", compact && "hidden sm:inline")}>
        Mi<span className="text-brand-600">PahCertificar</span>
      </span>
    </span>
  );
}
